import api from '@/api/axiosConfig.js';

const BASE = '/api/operacion-sucursales';

const unwrap = (response) => response?.data?.data ?? response?.data ?? null;

const isNotFound = (error) => Number(error?.response?.status || 0) === 404;

async function getWithFallback(primaryPath, fallbackPath, config = {}) {
  try {
    return await api.get(primaryPath, config);
  } catch (error) {
    if (!fallbackPath || !isNotFound(error)) {
      throw error;
    }
    return api.get(fallbackPath, config);
  }
}

export const getApiErrorMessage = (error, fallback = 'No se pudo completar la operacion') => {
  const details = error?.response?.data?.details;
  const baseMessage = error?.response?.data?.message
    || error?.response?.data?.error
    || error?.message
    || fallback;

  if (Array.isArray(details) && details.length) {
    return `${baseMessage}: ${details.join(', ')}`;
  }

  return baseMessage;
};

export async function listSucursalesOperativas(params = {}) {
  const response = await api.get(`${BASE}/sucursales`, { params });
  return unwrap(response);
}

export async function listProvinciasOperativas() {
  const response = await getWithFallback(
    `${BASE}/catalogos/provincias`,
    `${BASE}/provincias`,
  );
  return unwrap(response);
}

export async function listLocalidadesOperativas(params = {}) {
  const response = await getWithFallback(
    `${BASE}/catalogos/localidades`,
    `${BASE}/localidades`,
    { params },
  );
  return unwrap(response);
}

export async function getSucursalOperativa(id) {
  const response = await api.get(`${BASE}/sucursales/${id}`);
  return unwrap(response);
}

export async function listEmpresasRedespacho(params = {}) {
  const response = await api.get(`${BASE}/empresas-redespacho`, { params });
  return unwrap(response);
}

export async function getEmpresaRedespacho(id) {
  const response = await api.get(`${BASE}/empresas-redespacho/${id}`);
  return unwrap(response);
}

export async function createEmpresaRedespacho(payload) {
  const response = await api.post(`${BASE}/empresas-redespacho`, payload);
  return unwrap(response);
}

export async function updateEmpresaRedespacho(id, payload) {
  const response = await api.put(`${BASE}/empresas-redespacho/${id}`, payload);
  return unwrap(response);
}

export async function deleteEmpresaRedespacho(id) {
  const response = await api.delete(`${BASE}/empresas-redespacho/${id}`);
  return unwrap(response);
}

export async function createSucursalOperativa(payload) {
  const response = await api.post(`${BASE}/sucursales`, payload);
  return unwrap(response);
}

export async function updateSucursalOperativa(id, payload) {
  const response = await api.put(`${BASE}/sucursales/${id}`, payload);
  return unwrap(response);
}

export async function toggleSucursalOperativa(id, activa) {
  const response = await api.patch(`${BASE}/sucursales/${id}/estado`, { activa });
  return unwrap(response);
}

export async function listLocalidadesAtendidas(params = {}) {
  const response = await api.get(`${BASE}/localidades-atendidas`, { params });
  return unwrap(response);
}

export async function lookupLocalidadAtendida(params = {}) {
  const response = await api.get(`${BASE}/localidades-atendidas/lookup`, { params });
  return unwrap(response);
}

export async function createLocalidadAtendida(payload) {
  const response = await api.post(`${BASE}/localidades-atendidas`, payload);
  return unwrap(response);
}

export async function updateLocalidadAtendida(id, payload) {
  const response = await api.put(`${BASE}/localidades-atendidas/${id}`, payload);
  return unwrap(response);
}

export async function deleteLocalidadAtendida(id) {
  const response = await api.delete(`${BASE}/localidades-atendidas/${id}`);
  return unwrap(response);
}

export async function listRutasDistribucion(params = {}) {
  const response = await api.get(`${BASE}/rutas-distribucion`, { params });
  return unwrap(response);
}

export async function createRutaDistribucion(payload) {
  const response = await api.post(`${BASE}/rutas-distribucion`, payload);
  return unwrap(response);
}

export async function updateRutaDistribucion(id, payload) {
  const response = await api.put(`${BASE}/rutas-distribucion/${id}`, payload);
  return unwrap(response);
}

export async function deleteRutaDistribucion(id) {
  const response = await api.delete(`${BASE}/rutas-distribucion/${id}`);
  return unwrap(response);
}

export async function previewRoutingGuia(payload) {
  const response = await api.post(`${BASE}/routing/preview`, payload);
  return unwrap(response);
}

export async function listPendientesRecanalizacion(params = {}) {
  const response = await api.get(`${BASE}/recanalizacion/pendientes`, { params });
  return unwrap(response);
}
